import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';

import getRequest from './base/get';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch stations API
   * @param query
   */
  fetchReportList: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/list-power-consumed`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch stations API for export
   * @param query
   */
  fetchReportListExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/list-power-consumed/export-data`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch power consumed report API
   * @param query
   */
  getPowerConsumedReport: (query: QueryParameters) =>
    getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/power-consumption-report`,
      { ...query },
    ),
  /**
   * Fetch power consumed month wise API
   * @param query
   */
  getPowerConsumedMonthWise: () =>
    getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/power-consumed-month-wise`,
    ),
  /**
   * Fetch devices API
   * @param query
   */
  getChargingPointCount: () =>
    getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-charging-points`),

  /**
   * Fetch report API
   * @returns
   */
  fetchListFilters: () => {
    return getRequest(`${config.reportApiUrl}api/facility/v1/charging-transaction/list-filters`);
  },
};
